var React = require('react');

function CheckmarkgreenInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4 12.5028L5.44822 10.6203L9.2136 13.8061L15.2961 7L17.034 8.59292L9.35843 16.9919L4 12.5028Z","fill":"#278281"}));
}

CheckmarkgreenInline.defaultProps = {"width":"22","height":"23","viewBox":"0 0 22 23","fill":"none"};

module.exports = CheckmarkgreenInline;

CheckmarkgreenInline.default = CheckmarkgreenInline;
